export default "__VITE_ASSET__cd06b147__"